import React, { useState } from "react"
import { Button } from "../../../ui/button"
import { ArrowRight } from "lucide-react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from "../../../ui/dialog"
import { Input } from "../../../ui/input"
import { Label } from "../../../ui/label"
import { toast } from "../../../ui/sonner"

const CTASection = () => {
  const [open, setOpen] = useState(false)
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")

  const handleSubmit = e => {
    e.preventDefault()
    // Here you would typically handle form submission to a backend
    toast.success("Your message has been sent!", {
      description: "We'll get back to you soon."
    })
    setOpen(false)
    setName("")
    setEmail("")
    setMessage("")
  }

  return (
    <section className="py-8 sm:py-10 md:py-12 lg:py-16 bg-oye-light-purple relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 md:mb-5 text-black">
            Don't see a perfect fit? <br className="hidden sm:block" />
            <span className="text-[#E563A4]">Let's chat anyway!</span>
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-gray-700 mb-5 sm:mb-6 md:mb-8">
            We're always on the lookout for exceptional talent. Send us your
            resume and tell us why you're excited about Oye Creator. We might
            just create a role for you!
          </p>
          <Button
            onClick={() => setOpen(true)}
            className="bg-oye-pink hover:bg-oye-pink/90 text-white px-6 sm:px-8 py-2.5 sm:py-3 md:py-4 lg:py-6 rounded-lg sm:rounded-xl lg:rounded-2xl text-sm sm:text-base md:text-lg flex items-center gap-2 mx-auto"
          >
            Get in touch
            <ArrowRight size={18} />
          </Button>

          <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="w-[95%] sm:max-w-md md:max-w-lg m-4 sm:m-auto">
              <DialogHeader>
                <DialogTitle className="text-xl sm:text-2xl">
                  Get in Touch
                </DialogTitle>
                <DialogDescription>
                  Fill out the form below and we'll get back to you as soon as
                  possible.
                </DialogDescription>
              </DialogHeader>
              <form onSubmit={handleSubmit} className="space-y-4 py-4">
                <div className="space-y-2">
                  <Label htmlFor="name">Name</Label>
                  <Input
                    id="name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    placeholder="Your name"
                    required
                    className="h-10 sm:h-11"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Your email"
                    required
                    className="h-10 sm:h-11"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="message">Message</Label>
                  <textarea
                    id="message"
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                    className="w-full min-h-[80px] sm:min-h-[100px] p-3 rounded-md border border-solid border-input bg-background"
                    placeholder="Tell us about yourself and why you're interested in Oye Creator"
                    required
                  />
                </div>
                <DialogFooter className="pt-4 sm:flex-row">
                  <Button
                    type="submit"
                    className="w-full sm:w-auto bg-oye-pink hover:bg-oye-pink/90"
                  >
                    Send Message
                  </Button>
                </DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </section>
  )
}

export default CTASection
